<template>
  <div id="bo-free-caracteristics">
    <div class="row">
      <div class="col-xs-12">
        <h1 class="text-primary">
          <small>Données importées</small>
          <br>
          Caractéristiques
        </h1>
        <hr>
      </div>
    </div>
    <div class="panel panel-info">
      <div class="panel-heading">
        <div class="panel-title">
          <div class="form-inline">
            <div class="form-group">
              <btn class="btn-primary"
                   @click="$refs.fileInput.click()">
                Importer depuis un .csv
                <input ref="fileInput"
                       v-show="false"
                       type="file"
                       @change="importFromCSV"
                       single>
              </btn>
            </div>
            <div class="form-group" v-if="sheets">
              <sui-check-box size="xs"
                             type="reaExplaur"
                             v-model="sortRepValues">
                Trier les valeurs des distributions
              </sui-check-box>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="display && this.all">
      <div class="col-xs-12">
        <sui-filter-input v-model="filteredSheets"
                          :list="sheets"
                          :variables="filterVariables">
          <template slot="sticky-footer">
            <div class="row sticky-footer">
              <div class="col-xs-12">
                <btn type="success" @click="applyFilter()"
                     :disabled="filteredSheets.status === 2" size="sm">
                  Appliquer
                </btn>
                <span v-if="currentFilter !== ''">
                  <btn type="default" size="sm" disabled>
                    Filtre en cours :
                    «<span class="current-filter">{{currentFilter}}</span>»
                  </btn>
                  <btn type="default" @click="resetFilter()" size="sm">
                    Effacer
                  </btn>
                </span>
              </div>
            </div>
          </template>
        </sui-filter-input>
      </div>
      <div class="col-xs-12">
        <hr>
        <tabs>
          <tab title="Liste">
            <sui-results-caracteristics
              :caracteristics="flat.characteristics"
              :title="'Caractéristiques libres'"
              :subtitle="'Fichier importé'">
              <p>Aucune donnée.</p>
            </sui-results-caracteristics>
          </tab>
          <tab title="Focus">
            <div class="row">
              <div class="col-xs-12">
                <h4>Sélection de la ligne</h4>
                <div class="form-group">
                  <div class="input-group carac-input">
                    <input required
                           ref="input"
                           id="highlightSelector"
                           tabindex="0"
                           class="form-control"
                           v-model="focus.text"
                           type="text"
                           placeholder="Taper le nom de la caractéristique"
                           autocomplete="off"/>
                  </div>
                  <typeahead v-model="focus.model"
                             open-on-focus
                             force-select
                             ignore-case
                             target="#highlightSelector"
                             :limit="50"
                             :data="focusList"
                             item-key="value"/>
                </div>
                <btn @click="focus.showList = !focus.showList" size="xs">
                  Liste complète
                </btn>
                <collapse v-model="focus.showList">
                  <table class="table table-responsive table-striped">
                    <tbody>
                      <tr v-for="(fl, i) in focusListDisplay"
                          :key="`focus-list-${i}`">
                        <td :class="`focus-list-${fl.style}`">{{ fl.value }}</td>
                      </tr>
                    </tbody>
                  </table>
                </collapse>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">

                <h4>Sélection de la colonne</h4>
                <div class="form-group">
                  <div class="input-group carac-input">
                    <input required
                           ref="input"
                           id="columnSelector"
                           tabindex="0"
                           class="form-control"
                           v-model="focus.columnText"
                           type="text"
                           placeholder="Taper le nom de la caractéristique"
                           autocomplete="off"/>
                  </div>
                  <typeahead v-model="focus.column"
                             open-on-focus
                             force-select
                             ignore-case
                             target="#columnSelector"
                             :limit="50"
                             :data="focusList"
                             item-key="value"/>
                </div>
              </div>
            </div>

            <div v-if="highlight">
              <sui-evol-carac :sources="evolutionSources"
                              :field-info="highlight"
                              :alwaysShowTestStatResult="false">
              </sui-evol-carac>
            </div>
          </tab>
        </tabs>
      </div>
    </div>
  </div>
</template>

<script>
import caracteristics from '@/sui/data/caracteristics'
import suiCheckbox from '@/sui/components/checkbox'
import suiFilterInput from '@/sui/components/dataFilterInput'
import suiResultsCaracteristics from '@/sui/components/results/caracteristics'
import suiEvolCarac from '@/sui/components/evolution/caracteristics'
import assert from '@/sui/tools/assert'
import rtti from '@/sui/tools/rtti'
import ice from '@/sui/tools/ice'

import boImportCSV from '@/components/import/csv'

import parse from 'csv-parse'
import clone from 'clone'

export default {
  name: 'bo-free-caracteristics',

  data: function () {
    return {
      sortRepValues: false,
      csvFile: null,
      filteredSheets: { filter: '', list: [] },
      currentFilter: '',
      currentList: [],
      all: null,
      focus: {
        text: '',
        model: null,
        showList: false
      }
    }
  },

  methods: {
    importFromCSV: function (event) {
      this.csvFile = event.target.files[0]
      this.$refs.fileInput.value = ''
    },

    resetFilter: function () {
      this.filteredSheets.filter = this.currentFilter = ''
      this.currentList = []
    },

    applyFilter: function () {
      if (this.filteredSheets.filter === '' ||
          this.filteredSheets.status === 2) {
        return
      }

      this.currentFilter = this.filteredSheets.filter
      this.currentList = this.filteredSheets.list
    },

    parseCSV: function (e) {
      const vm = this
      parse(
        e.target.result,
        {
          comment: '#',
          columns: true,
          columns_duplicates_to_array: true,
          delimiter: ';',
          skip_empty_lines: true
        },
        (err, output) => {
          if (err != null) {
            vm.$notify({
              type: 'danger',
              title: 'Erreur !',
              content: `Impossible de charger le fichier csv: ${err}.`
            })
          } else if (output.length === 0) {
            vm.$notify({
              type: 'warning',
              title: 'Attention !',
              content: `Le fichier ne contient aucune donnée.`
            })
          } else {
            vm.all = output
          }
        }
      )
    }
  },

  watch: {
    csvFile (value) {
      if (value == null) {
        return
      }

      this.all = null

      const file = value
      const reader = new FileReader()

      reader.onload = this.parseCSV
      reader.readAsText(file)
    }
  },

  computed: {
    columnsConfig: function () {
      if (this.all == null) {
        return null
      }

      return this.all[0]
    },

    sheets: function () {
      if (this.all == null) {
        return null
      }

      return this.all.slice(1)
    },

    display: function () {
      return this.all != null
    },

    referenceSheets: function () {
      if (this.sheets == null) {
        return null
      }

      if (this.currentFilter === '') {
        return this.sheets
      }

      return this.currentList
    },

    filterVariables: function () {
      const variables = []
      for (let key in this.columnsConfig) {
        const prefix = key.match(/(^[0-9]+)/)
        const v = key.replace(
          /[^a-zA-Zéè '°_0-9]+/g, ''
        ).replace(
          /[ '-]/g, '_'
        ).replace(/^_|_$/g, '')

        variables.push(
          {
            key: prefix != null ? `N${prefix[0]}_${v}` : v,
            name: key,
            field: (s) => [ s[key] ]
          }
        )
      }
      return variables
    },

    flat: function () {
      if (this.referenceSheets == null) {
        return null
      }

      const section = {
        title: 'Caractéristiques',
        key: 'car',
        list: []
      }
      const config = this.columnsConfig
      const dist = {}
      for (let key in config) {
        const t = config[key]
        if (t != null && t !== '') {
          if (dist[key] != null) {
            this.$notify(
              {
                type: 'danger',
                title: 'Erreur !',
                content: `Doublon de colonnes : ${key}`
              }
            )
            return null
          }

          const field = {
            f: key,
            t: key,
            v: []
          }

          if (t === 'dist') {
            dist[key] = {
              type: 'rep',
              values: {},
              total: 0
            }
          } else if (t === 'mm') {
            dist[key] = {
              type: 'mm',
              total: 0,
              sum: 0,
              values: []
            }
          }

          section.list.push(field)
        }
      }

      for (let i = 0; i !== this.referenceSheets.length; ++i) {
        const sheet = this.referenceSheets[i]
        for (let j = 0; j !== section.list.length; ++j) {
          const cfg = section.list[j]

          const v = sheet[cfg.f]
          if (v == null || v === '') {
            continue
          }

          if (rtti.isArray(v)) {
            this.$notify(
              {
                type: 'danger',
                title: 'Erreur !',
                content: `Doublon de colonnes : ${cfg.f}`
              }
            )
            return null
          }

          const t = dist[cfg.f]
          assert.notNull(t)

          ++t.total
          if (t.type === 'rep') {
            if (t.values[v] == null) {
              t.values[v] = 1
              cfg.v.push(
                {
                  code: v,
                  value: v
                }
              )
            } else {
              t.values[v] += 1
            }
          } else if (t.type === 'mm') {
            const value = parseFloat(v)
            t.sum += value
            t.values.push(value)
          }
        }
      }

      for (let i = 0; i !== section.list.length; ++i) {
        const cfg = section.list[i]
        const data = dist[cfg.f]

        if (this.sortRepValues && data.type === 'rep') {
          const values = data.values
          cfg.v = cfg.v.sort(
            (a, b) => {
              return values[b.code] - values[a.code]
            }
          )
        } else {
          cfg.v = cfg.v.sort(
            (a, b) => a.code.padStart(20, '0').localeCompare(b.code.padStart(20, '0'))
          )
        }
      }

      return {
        characteristics: caracteristics.flatten.flatten([section], dist),
        distribution: dist,
        sections: [section]
      }
    },

    focusList: function () {
      if (this.flat == null) {
        return []
      }
      const list = this.flat.sections
      const fieldsByTitles = {}
      const orderedTitles = []
      for (let i = 0; i !== list.length; ++i) {
        const c = list[i]
        const displayAllValues = c.displayAllValues
        let subtitle = ''
        for (let j = 0; j !== c.list.length; ++j) {
          const f = c.list[j]
          if (f.h) {
            subtitle = f.t
            continue
          }
          const title = c.title
          const newField = clone(f)
          newField.v = newField.v.sort((f, s) => f.code > s.code)

          const elt = {
            field: newField,
            origin: f,
            title: title,
            subtitle: subtitle,
            value: `${f.f} => ${f.t}`,
            displayAllValues: displayAllValues
          }

          const r1 = fieldsByTitles[title]
          if (r1 == null) {
            orderedTitles.push(title)
            const add = {}
            add[subtitle] = [elt]
            fieldsByTitles[title] = add
          } else {
            const r2 = r1[subtitle]
            if (r2 == null) {
              r1[subtitle] = [elt]
            } else {
              r2.push(elt)
            }
          }
        }
      }

      const result = []
      for (let i = 0; i < orderedTitles.length; i++) {
        const title = orderedTitles[i]
        const fieldsBySubtitles = fieldsByTitles[title]
        assert.notNull(fieldsBySubtitles)

        for (let j in fieldsBySubtitles) {
          const fields = fieldsBySubtitles[j]

          for (let k = 0; k < fields.length; k++) {
            const f = fields[k]
            result.push(f)
          }
        }
      }

      return ice.freeze(result)
    },

    focusListDisplay: function () {
      const result = []
      const previous = {
        title: '',
        subtitle: ''
      }
      for (let i = 0; i !== this.focusList.length; ++i) {
        const focus = this.focusList[i]
        if (focus.title !== previous.title) {
          result.push({ style: 'title', value: focus.title })
          previous.title = focus.title
          previous.subtitle = ''
        }

        if (focus.subtitle !== previous.subtitle) {
          result.push({ style: 'subtitle', value: focus.subtitle })
          previous.subtitle = focus.subtitle
        }

        result.push({ style: 'value', value: focus.value })
      }
      return result
    },

    highlight: function () {
      const m = this.focus.model
      if (m == null) {
        return null
      }

      return {
        field: m.field,
        title: m.title,
        subtitle: m.subtitle,
        displayAllValues: m.displayAllValues
      }
    },

    evolutionSources: function () {
      if (this.focus.column == null) {
        return [{ year: 'TOUT', dist: this.flat.distribution }]
      }

      const none = '(Aucun)'
      const dist = {}
      dist[none] = {}
      const values = this.focus.column.field.v

      assert.notNull(values, 'invalid focus column field name')
      for (let i = 0; i !== values.length; ++i) {
        const key = values[i].code
        dist[key] = {}
      }

      const config = this.columnsConfig
      assert.notNull(config, 'invalid columns configuration')
      for (let col in dist) {
        const target = dist[col]

        for (let key in config) {
          const t = config[key]
          if (t === 'dist') {
            target[key] = {
              type: 'rep',
              values: {},
              total: 0
            }
          } else if (t === 'mm') {
            target[key] = {
              type: 'mm',
              total: 0,
              sum: 0,
              values: []
            }
          }
        }
      }

      const section = this.flat.sections[0]
      for (let i = 0; i !== this.referenceSheets.length; ++i) {
        const sheet = this.referenceSheets[i]
        const column = sheet[this.focus.column.field.f]
        const targetKey = column == null || column === '' ? none : column
        let target = dist[targetKey]
        if (target == null) {
          target = {}
          const config = this.columnsConfig
          assert.notNull(config, 'invalid columns configuration')
          for (let key in config) {
            const t = config[key]
            if (t === 'dist') {
              target[key] = {
                type: 'rep',
                values: {},
                total: 0
              }
            } else if (t === 'mm') {
              target[key] = {
                type: 'mm',
                total: 0,
                sum: 0,
                values: []
              }
            }
          }
          dist[targetKey] = target
        }
        assert.notNull(target, `invalid target for column ${column}`)

        for (let j = 0; j !== section.list.length; ++j) {
          const cfg = section.list[j]

          const v = sheet[cfg.f]
          if (v == null || v === '') {
            continue
          }

          const t = target[cfg.f]
          assert.notNull(t, `uninitialized field ${cfg.f} in column ${column}`)

          ++t.total
          if (t.type === 'rep') {
            if (t.values[v] == null) {
              t.values[v] = 1
            } else {
              t.values[v] += 1
            }
          } else if (t.type === 'mm') {
            const value = parseFloat(v)
            t.sum += value
            t.values.push(value)
          }
        }
      }

      const result = []
      for (let k in dist) {
        result.push(
          { year: k, dist: dist[k] }
        )
      }

      return ice.freeze(result)
    }
  },

  components: {
    'sui-evol-carac': suiEvolCarac,
    'bo-import-csv': boImportCSV,
    'sui-results-caracteristics': suiResultsCaracteristics,
    'sui-filter-input': suiFilterInput,
    'sui-check-box': suiCheckbox
  }
}
</script>

<style>
</style>
